import { cx } from "@/utils/cx";

const sizes = {
	"2xl": "size-4",
	"3xl": "size-4.5",
	"4xl": "size-5",
	lg: "size-3",
	md: "size-2.5",
	sm: "size-2",
	xl: "size-3.5",
	xs: "size-1.5",
};

interface AvatarOnlineIndicatorProps {
	className?: string;
	size: "2xl" | "3xl" | "4xl" | "lg" | "md" | "sm" | "xl" | "xs";
	status: "offline" | "online";
}

export const AvatarOnlineIndicator = ({
	className,
	size,
	status,
}: AvatarOnlineIndicatorProps) => (
	<span
		className={cx(
			"absolute right-0 bottom-0 rounded-full ring-[1.5px] ring-bg-primary",
			status === "online" ? "bg-fg-success-secondary" : "bg-fg-disabled_subtle",
			sizes[size],
			className,
		)}
	/>
);
